import { useEffect } from "react"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { isLoadingAdminBrands, tableData } from "../@signals"


export default function useAdminBrandSearch() {

    useEffect(() => {
        fetchBrands()
    }, [])

    const fetchBrands = () => {
        isLoadingAdminBrands.value = true
        tableData.value = []
        postSubmit(`${BACKEND_APIS.BRANDS}/crud/context`, {}).then(res => {
            tableData.value = res || []
            isLoadingAdminBrands.value = false
        }).catch(() => {
            tableData.value = []
            isLoadingAdminBrands.value = false
        })
    }

    return { fetchBrands }
}
